
import {
    claimantIsPolicyholder,
    claimantTitleCompare,
    claimantFirstnameCompare,
    claimantLastnameCompare,
    claimantEmailCompare,
    claimantTelephoneCompare } from './claimantRules.js'

let claimantComparePipeline = {
    id: 4,
    name: 'claimantComparePipeline',
    rules: [
        claimantIsPolicyholder,
        claimantTitleCompare,
        claimantFirstnameCompare,
        claimantLastnameCompare,
        claimantEmailCompare,
        claimantTelephoneCompare
    ]
}

export { claimantComparePipeline }